import { render, staticRenderFns } from "./DiscountPlanList.vue?vue&type=template&id=6e189a3c&"
import script from "./DiscountPlanList.vue?vue&type=script&lang=js&"
export * from "./DiscountPlanList.vue?vue&type=script&lang=js&"
import style0 from "./DiscountPlanList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports